export default __webpack_public_path__ + "static/media/genuine-laminate.5c295ab5.png";